import { useBooking } from "@/context/BookingContext";
import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { INSTAGRAM_URL } from "@/lib/images";

export default function Footer() {
  const { openBooking } = useBooking();
  const links = [
    { label: "Home", href: "#home" },
    { label: "Services", href: "#services" },
    { label: "About", href: "#about" },
    { label: "FAQ", href: "#faq" },
    { label: "Instagram", href: INSTAGRAM_URL, external: true },
  ];

  return (
    <footer id="contact" data-testid="footer" className="bg-[#1C1917] text-white">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <div className="font-serif text-4xl sm:text-5xl font-medium tracking-tight leading-none">
            Slavic Lashes<br />&amp; Brows
          </div>
          <p className="text-white/40 mt-6 text-[11px] tracking-[0.3em] uppercase">Moonee Ponds · Melbourne</p>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-2 mt-8 text-[#C5B382] text-sm hover:text-white transition-colors"
          >
            <Instagram size={18} /> @slavic.lashes.brows
          </a>
        </div>

        <div className="md:col-span-3">
          <div className="text-white/40 text-[10px] tracking-[0.3em] uppercase mb-5">Explore</div>
          <ul className="space-y-3">
            {links.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  className="text-white/70 hover:text-[#C5B382] text-sm transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <button onClick={() => openBooking()} data-testid="footer-book" className="text-white/70 hover:text-[#C5B382] text-sm transition-colors">Book</button>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-white/40 text-[10px] tracking-[0.3em] uppercase mb-5">Legal</div>
          <ul className="space-y-3">
            <li><Link to="/policy" data-testid="footer-policy" className="text-white/70 hover:text-[#C5B382] text-sm transition-colors">Booking Policy</Link></li>
            {["Privacy Policy", "Terms & Conditions", "Cancellation Policy"].map((p) => (
              <li key={p}><Link to="/policy" className="text-white/50 hover:text-[#C5B382] text-xs transition-colors">{p}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-10 py-6 pb-28 lg:pb-6 flex flex-col sm:flex-row justify-between gap-3 text-white/40 text-xs">
          <span>© {new Date().getFullYear()} Slavic Lashes &amp; Brows. All rights reserved.</span>
          <span>Moonee Ponds · Melbourne</span>
        </div>
      </div>
    </footer>
  );
}
